import axios from "axios";

import { apiDomain } from "../../store/constants";

const Extend = {
  getExtendForms(data) {
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "GET",
      params: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  getExtendFormById(data) {
    return axios({
      url: apiDomain + `api/pending-form/${data.id}`,
      method: "GET",
      params: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  createExtendForm(data) {
    return axios({
      url: apiDomain + `api/pending-form/create?id=${data.id}`,
      method: "GET",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  saveExtendForm(data) {
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "POST",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  editExtendForm(data) {
    return axios({
      url: apiDomain + `api/pending-form/${data.id}/edit`,
      method: "GET",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  updateExtendForm(data) {
    return axios({
      url: apiDomain + `api/pending-form/${data.id}`,
      method: "PUT",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Extend;
